import { render, staticRenderFns } from "./AccessPoints.vue?vue&type=template&id=6d3925b8&scoped=true&"
import script from "./AccessPoints.vue?vue&type=script&lang=js&"
export * from "./AccessPoints.vue?vue&type=script&lang=js&"
import style0 from "./AccessPoints.vue?vue&type=style&index=0&id=6d3925b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3925b8",
  null
  
)

export default component.exports